import { useState, useEffect, useRef } from 'react';
import '../pages/AuthorProfile.css';
import { TOUR_PHOTOS_2026 } from './TourFigure';
import { TRIPADVISOR_RATING, TRIPADVISOR_REVIEW_COUNT } from '../data/reviewStats';
import { useLocation } from 'react-router-dom';
import { isArPath } from '../i18nRoutes';

export const REVIEW_META_AR = {"Australia": "أستراليا", "Raleigh, NC": "رالي، نورث كارولاينا", "Old City Tour · July 2026": "جولة المدينة القديمة · يوليو 2026", "June 2026": "يونيو 2026", "May 2026": "مايو 2026", "April 2026": "أبريل 2026", "September 2025": "سبتمبر 2025", "August 2025": "أغسطس 2025"};
const arText = (isAr, en, ar) => (isAr && ar ? ar : en);
const metaAr = (isAr, v, ar) => (isAr && ((ar) || (v && REVIEW_META_AR[v]))) || v;

const TA_URL = 'https://www.tripadvisor.com/Attraction_Review-g293974-d25289505-Reviews-Viaturkey_Tours-Istanbul.html';

/* ═══ 2026 Tour Photos ═══ */
const TOUR_PHOTOS = [
  TOUR_PHOTOS_2026.blueMosqueTwoGuests,
  TOUR_PHOTOS_2026.blueMosqueSmallGroup,
  TOUR_PHOTOS_2026.hagiaSophiaGallery,
  { src: '/images/tours-2026/basilica-cistern-guests-akin-guzel.webp', caption: 'Basilica Cistern with guests', alt: 'Guide Akın Güzel with two guests among the illuminated columns of the Basilica Cistern, Istanbul', width: 1600, height: 1200 },
  { src: '/images/tours-2026/german-fountain-sultanahmet-guests.webp', caption: 'German Fountain, Sultanahmet', alt: 'Tour guests at the German Fountain in Sultanahmet Square with the Blue Mosque minarets behind, Istanbul', width: 900, height: 1600 },
  { src: '/images/tours-2026/topkapi-palace-harem-terrace-akin-guzel.webp', caption: 'Topkapı Palace Harem terrace', alt: 'Guide Akın Güzel on the tiled terrace of the Topkapı Palace Harem, Istanbul', width: 1200, height: 1600 },
  { src: '/images/tours-2026/sultanahmet-square-plane-trees.webp', caption: 'Under the plane trees of Sultanahmet', alt: 'Shaded promenade under the plane trees of Sultanahmet Square, Istanbul', width: 900, height: 1600 },
  { src: '/images/tours-2026/bosphorus-bridge-kucuksu-guests.webp', width: 1400, height: 1050, caption: 'Bosphorus Bridge & Küçüksu', captionAr: 'جسر البوسفور وقصر كوتشوك صو', altAr: 'ضيوف الجولة عند قصر كوتشوك صو مع جسر البوسفور، إسطنبول 2026', alt: 'Tour guests at Küçüksu Pavilion with Bosphorus Bridge, Istanbul 2026' },
  { src: '/images/tours-2026/grand-bazaar-textile-tour.webp', width: 1400, height: 1050, caption: 'Grand Bazaar Textile Tour', captionAr: 'جولة الأقمشة في البازار الكبير', altAr: 'ضيوف الجولة يتفقّدون الأقمشة التركية في البازار الكبير، إسطنبول 2026', alt: 'Tour guests exploring Turkish textiles at the Grand Bazaar, Istanbul 2026' },
  { src: '/images/tours-2026/dolmabahce-palace-guests.webp', width: 1100, height: 1467, caption: 'Dolmabahçe Palace', captionAr: 'قصر دولمة بهجة', altAr: 'ضيوف الجولة أمام قصر دولمة بهجة، إسطنبول 2026', alt: 'Tour guests in front of Dolmabahçe Palace, Istanbul 2026' },
  { src: '/images/tours-2026/turkish-ice-cream-fun.webp', width: 1400, height: 1050, caption: 'Turkish Ice Cream Fun', captionAr: 'متعة البوظة التركية', altAr: 'ضيف يستمتع بالبوظة التركية قرب ترام السلطان أحمد، إسطنبول 2026', alt: 'Guest enjoying Turkish ice cream near Sultanahmet tram, Istanbul 2026' },
  { src: '/images/tours-2026/istanbul-tram-ride-guests.webp', width: 1400, height: 1050, caption: 'Istanbul Tram Ride', captionAr: 'جولة بترام إسطنبول', altAr: 'ضيوف الجولة في ترام إسطنبول الشهير، 2026', alt: 'Tour guests on the iconic Istanbul tram, 2026' },
  { src: '/images/tours-2026/blue-mosque-interior-guests.webp', width: 1600, height: 1200, caption: 'Blue Mosque Interior', captionAr: 'من داخل المسجد الأزرق', altAr: 'ضيوف الجولة داخل المسجد الأزرق تحت النوافذ الزجاجية الملوّنة، إسطنبول', alt: 'Tour guests inside the Blue Mosque under stained glass windows, Istanbul' },
  { src: '/images/tours-2026/basilica-cistern-guests.webp', width: 1600, height: 1200, caption: 'Basilica Cistern', captionAr: 'صهريج البازيليك', altAr: 'ضيوف الجولة بين أعمدة صهريج البازيليك الأثرية في إسطنبول', alt: 'Tour guests among the ancient columns of the Basilica Cistern, Istanbul' },
  { src: '/images/tours-2026/dolmabahce-palace-halls-akin.webp', width: 1500, height: 2000, caption: 'Dolmabahçe Palace Halls', captionAr: 'قاعات قصر دولمة بهجة', altAr: 'المرشد أكين في قاعات قصر دولمة بهجة المضاءة بالثريات، إسطنبول', alt: 'Guide Akın in the chandelier-lit halls of Dolmabahçe Palace, Istanbul' },
  { src: '/images/tours-2026/bosphorus-ferry-ride-guests.webp', width: 1600, height: 1199, caption: 'Bosphorus Ferry Ride', captionAr: 'رحلة العبّارة في البوسفور', altAr: 'ضيوف الجولة في محطة العبّارات قبل عبور البوسفور، إسطنبول', alt: 'Tour guests at the Istanbul ferry terminal before a Bosphorus crossing' },
  { src: '/images/tours-2026/maras-ice-cream-stop.webp', width: 1600, height: 900, caption: 'Maraş Ice Cream Stop', captionAr: 'استراحة بوظة مرعش', altAr: 'بائع بوظة مرعش التقليدية يقدّم عرضه لضيوف الجولة في إسطنبول', alt: 'Traditional Maraş ice cream vendor performing for tour guests in Istanbul' },
  { src: '/images/tours-2026/galata-tower-walk-akin.webp', width: 1500, height: 2000, caption: 'Galata Tower Walk', captionAr: 'جولة سير إلى برج غلطة', altAr: 'المرشد أكين وبرج غلطة يعلو الزحام في بيوغلو، إسطنبول', alt: 'Guide Akın with the Galata Tower rising above the crowds in Beyoğlu, Istanbul' },
  { src: '/images/tours-2026/galataport-cruise-terminal.webp', width: 1600, height: 1200, caption: 'Galataport Cruise Terminal', captionAr: 'محطة غلطة بورت للسفن السياحية', altAr: 'مدخل محطة غلطة بورت للسفن السياحية حيث نستقبل ضيوف الجولات الشاطئية', alt: 'Galataport Istanbul cruise terminal entrance where shore excursion guests are met' },
  { src: '/images/tours-2026/cruise-ship-at-galataport.webp', width: 828, height: 1097, caption: 'Cruise Ship at Galataport', captionAr: 'سفينة سياحية في غلطة بورت', altAr: 'سفينة سياحية راسية في غلطة بورت بإسطنبول من مقهى على الواجهة البحرية', alt: 'Cruise ship docked at Galataport Istanbul seen from a waterfront café' },
  { src: '/images/tours-2026/topkapi-palace-terrace.webp', width: 960, height: 1280, caption: 'Topkapi Palace Terrace', captionAr: 'شرفة قصر توبكابي', altAr: 'المرشد مع ضيف على شرفة قصر توبكابي المطلّة على البوسفور', alt: 'Guide with tour guest on the Topkapi Palace terrace overlooking the Bosphorus' },
  { src: '/images/tours-2026/column-of-constantine.webp', width: 1500, height: 2000, caption: 'Column of Constantine', captionAr: 'عمود قسطنطين', altAr: 'عمود قسطنطين الأثري (تشمبرليطاش) أمام سماء صافية في إسطنبول', alt: 'The ancient Column of Constantine (Çemberlitaş) against a blue sky in Istanbul' },
];

/* ═══ Featured 2026 Reviews (short quotes, <30 words) ═══ */
export const FEATURED = [
  { quote: "Absolutely worth it! Knowledgeable, kind, super flexible to our needs and wants during the day. It turned the visit into a journey of discovery, made history come to life. Very happy.", name: "Johannes S", quoteAr: "تستحق كل لحظة! واسع المعرفة، لطيف، ومرن جداً في تلبية احتياجاتنا ورغباتنا طوال اليوم. حوّل الزيارة إلى رحلة استكشاف، وجعل التاريخ ينبض بالحياة. نحن سعداء جداً.", title: "Great tour — very much recommended", titleAr: "جولة رائعة — أنصح بها بشدة", location: "", date: "Travelled with family · October 2026", dateAr: "مع العائلة · أكتوبر 2026" },
  { quote: "Akın made visiting all the main attractions hassle free and easy to enjoy. We walked at a gentle pace with lots of information shared and a lovely Turkish lunch.", name: "Meg O", quoteAr: "جعل أكين زيارة كل المعالم الرئيسية سهلة وممتعة بلا أي عناء. سرنا على مهل مع كمّ وافر من المعلومات، وغداء تركي لذيذ.", location: "Australia", date: "Old City Tour · July 2026" },
  { quote: "Relaxed, knowledgeable, personable and flexible. His relaxed demeanor in a chaotic city is a breath of fresh air — and no hard sells!", name: "Andrew H", quoteAr: "هادئ، واسع المعرفة، لطيف ومرن. هدوؤه وسط مدينة صاخبة يبعث على الارتياح — ودون أي إلحاح في البيع!", date: "June 2026", photo: TOUR_PHOTOS[7].src },
  { quote: "He put together a custom program based on my needs. Feels as much like a friend as a guide. My second time touring with him.", name: "Jim J", quoteAr: "أعدّ لي برنامجاً مخصّصاً حسب احتياجاتي. تشعر أنه صديق بقدر ما هو مرشد. وهذه رحلتي الثانية معه.", date: "May 2026", photo: TOUR_PHOTOS[8].src },
  { quote: "You felt as if you were hanging out with a longtime friend. He took us to the finest shopping and great restaurants.", name: "Viviana M", quoteAr: "تشعر وكأنك برفقة صديق قديم. اصطحبنا إلى أرقى أماكن التسوّق وأفضل المطاعم.", date: "May 2026", location: "Raleigh, NC", photo: TOUR_PHOTOS[11].src },
  { quote: "Akın was a great guide. Knowledgeable and manages the needs of his clients. Could not have been happier with our day in Istanbul!", name: "Hannah K", quoteAr: "كان أكين مرشداً رائعاً. واسع الاطّلاع ويلبّي احتياجات عملائه. لم نكن لنسعد أكثر بيومنا في إسطنبول!", date: "April 2026", photo: TOUR_PHOTOS[9].src },
  { quote: "Speaks English perfectly, very knowledgeable about every historical attraction. Always on time and a great guy to be around.", name: "Sotirios P", quoteAr: "يتحدث الإنجليزية بطلاقة، وملمّ بكل معلم تاريخي. دائم الالتزام بالمواعيد وشخص ممتع الصحبة.", date: "September 2025" },
  { quote: "Akın has been our family guide. Extremely caring and a thorough professional. He is a brother now!", name: "Shaheer J", quoteAr: "كان أكين مرشد عائلتنا. مهتمّ للغاية ومحترف بكل معنى الكلمة. أصبح أخاً لنا الآن!", date: "August 2025" },
];

export const LAYOVER_REVIEWS = [
  { quote: "We took the ferry to the Asian side, sipped black tea and ate local desserts. We'll definitely hit up Akın again!", quoteAr: "ركبنا العبّارة إلى الجانب الآسيوي، وارتشفنا الشاي الأسود، وتذوّقنا الحلويات المحلية. سنعود إلى أكين بالتأكيد!", name: "Dalmendral", location: "San Francisco", locationAr: "سان فرانسيسكو", date: "Layover Tour", dateAr: "جولة ترانزيت" },
  { quote: "Met me at the airport, we saw amazing mosques, the grand bazaar, and the waterfront where you could see Asia! He knows the city.", quoteAr: "استقبلني في المطار، ورأينا مساجد مذهلة، والبازار الكبير، والواجهة البحرية حيث يمكنك رؤية آسيا! إنه يعرف المدينة جيداً.", name: "gemm29", location: "Massachusetts", locationAr: "ماساتشوستس", date: "9-hour Layover", dateAr: "توقف 9 ساعات" },
];

/* Keep old keys for backward compat with pages that import them */
export const REVIEWS = {
  family: FEATURED[7],
  general: FEATURED[3],
  multiDay: FEATURED[2],
  parents: FEATURED[5],
  layover1: LAYOVER_REVIEWS[0],
  layover2: LAYOVER_REVIEWS[1],
};

export function ReviewCard({ review, className }) {
  return (
    <a href={TA_URL} target="_blank" rel="noopener noreferrer" className={`ta-review-card ${className || ''}`} data-testid="ta-review-card">
      <div className="ta-stars">{'★★★★★'}</div>
      <p className="ta-quote">{'\u201C'}{review.quote}{'\u201D'}</p>
      <div className="ta-review-footer">
        <span className="ta-reviewer">
          <strong>{review.name}</strong>
          {review.location && <>, {review.location}</>}
          {' '}— {review.date}
        </span>
        <span className="ta-verified">
          <i className="fab fa-tripadvisor"></i> Verified TripAdvisor Review
        </span>
      </div>
    </a>
  );
}

export function TrustBadge({ className }) {
  const isAr = isArPath(useLocation().pathname);
  return (
    <a href={TA_URL} target="_blank" rel="noopener noreferrer" className={`ta-trust-badge ${className || ''}`} data-testid="ta-trust-badge">
      <i className="fab fa-tripadvisor"></i>
      <span><strong>{TRIPADVISOR_RATING}/5</strong> {isAr ? 'على' : 'on'} TripAdvisor ({TRIPADVISOR_REVIEW_COUNT} {isAr ? 'تقييم' : 'reviews'})</span>
    </a>
  );
}

/* ═══ Tour Photo Gallery (auto-scrolling strip) ═══ */
function TourPhotoGallery({ isAr }) {
  const scrollRef = useRef(null);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let raf;
    let paused = false;
    const speed = 0.4;
    const scroll = () => {
      if (!paused && el.scrollWidth > el.clientWidth) {
        el.scrollLeft += speed;
        if (el.scrollLeft >= el.scrollWidth - el.clientWidth - 1) {
          el.scrollLeft = 0;
        }
      }
      raf = requestAnimationFrame(scroll);
    };
    raf = requestAnimationFrame(scroll);
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', resume);
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
      el.removeEventListener('touchstart', pause);
      el.removeEventListener('touchend', resume);
    };
  }, []);

  return (
    <>
      <div className="tour-photos-wrapper" data-testid="tour-photo-gallery">
        <h3 className="tour-photos-title">
          <i className="fas fa-camera"></i> {isAr ? 'جولاتنا في إسطنبول 2026' : '2026 Tours in Istanbul'}
        </h3>
        <div className="tour-photos-strip" ref={scrollRef}>
          {TOUR_PHOTOS.map((p, i) => (
            <button key={i} className="tour-photo-item" onClick={() => setLightbox(i)} data-testid={`tour-photo-${i}`} aria-label={arText(isAr, `View ${p.caption}`, p.captionAr)}>
              <img src={p.src} alt={arText(isAr, p.alt, p.altAr)} loading="lazy" width={p.width} height={p.height} />
              <span className="tour-photo-caption">{arText(isAr, p.caption, p.captionAr)}</span>
            </button>
          ))}
        </div>
      </div>
      {lightbox !== null && (
        <div className="tour-lightbox" onClick={() => setLightbox(null)} data-testid="tour-lightbox">
          <button className="tour-lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
            <i className="fas fa-times"></i>
          </button>
          <button className="tour-lightbox-nav prev" onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + TOUR_PHOTOS.length) % TOUR_PHOTOS.length); }} aria-label="Previous">
            <i className="fas fa-chevron-left"></i>
          </button>
          <div className="tour-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={TOUR_PHOTOS[lightbox].src} alt={arText(isAr, TOUR_PHOTOS[lightbox].alt, TOUR_PHOTOS[lightbox].altAr)} />
            <p className="tour-lightbox-caption">{arText(isAr, TOUR_PHOTOS[lightbox].caption, TOUR_PHOTOS[lightbox].captionAr)}</p>
          </div>
          <button className="tour-lightbox-nav next" onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % TOUR_PHOTOS.length); }} aria-label="Next">
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      )}
    </>
  );
}

/* ═══ Prominent Reviews Section (for homepage & /services) ═══ */
export function ReviewsShowcase({ reviews, layover }) {
  const isAr = isArPath(useLocation().pathname);
  const items = layover ? LAYOVER_REVIEWS : (reviews || FEATURED);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 600);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    const timer = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % items.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [isMobile, items.length]);

  return (
    <section className="reviews-showcase" data-testid="reviews-showcase">
      <div className="reviews-showcase-inner">
        <h2 className="reviews-showcase-heading">{isAr ? 'ماذا يقول ضيوفنا عنّا' : 'See What Our Guests Are Saying About Us'}</h2>
        <p className="reviews-showcase-sub">
          <i className="fab fa-tripadvisor"></i> <strong>{TRIPADVISOR_RATING}/5</strong> {isAr ? 'على' : 'on'} TripAdvisor — {TRIPADVISOR_REVIEW_COUNT} {isAr ? 'تقييماً موثّقاً' : 'Verified Reviews'}
        </p>
        {isAr && <p className="reviews-showcase-sub reviews-translated-note" data-testid="reviews-translated-note">تقييمات مترجمة من TripAdvisor</p>}

        {/* Tour Photos Gallery — only on main (non-layover) */}
        {!layover && <TourPhotoGallery isAr={isAr} />}

        {/* Desktop grid / Mobile carousel */}
        {isMobile ? (
          <div className="reviews-carousel" data-testid="reviews-carousel">
            <div className="reviews-carousel-track" style={{ transform: `translateX(-${activeSlide * 100}%)` }}>
              {items.map((r, i) => (
                <a href={TA_URL} target="_blank" rel="noopener noreferrer" key={i} className="reviews-showcase-card carousel-card" data-testid={`review-card-${i}`}>
                  {r.photo && <img src={r.photo} alt={isAr ? `صورة من جولة ${r.name}` : `${r.name} tour`} className="review-card-photo" loading="lazy" />}
                  <div className="ta-stars">{'★★★★★'}</div>
                  {r.title && <p className="review-title" data-testid={`review-title-${i}`}>{arText(isAr, r.title, r.titleAr)}</p>}
                  <p>{'\u201C'}{arText(isAr, r.quote, r.quoteAr)}{'\u201D'}</p>
                  <div className="reviews-showcase-author">
                    <strong>{r.name}</strong>
                    {r.location && <span className="reviews-loc">{metaAr(isAr, r.location, r.locationAr)}</span>}
                    <span className="reviews-date">{metaAr(isAr, r.date, r.dateAr)}</span>
                  </div>
                  <span className="ta-verified-sm"><i className="fab fa-tripadvisor"></i> {isAr ? 'تقييم موثّق على TripAdvisor' : 'Verified TripAdvisor Review'}</span>
                </a>
              ))}
            </div>
            <div className="reviews-carousel-dots">
              {items.map((_, i) => (
                <button key={i} className={`carousel-dot ${i === activeSlide ? 'active' : ''}`} onClick={() => setActiveSlide(i)} aria-label={`Review ${i + 1}`} data-testid={`carousel-dot-${i}`} />
              ))}
            </div>
          </div>
        ) : (
          <div className={`reviews-showcase-grid ${items.length <= 2 ? 'two-col' : ''}`}>
            {items.map((r, i) => (
              <a href={TA_URL} target="_blank" rel="noopener noreferrer" key={i} className="reviews-showcase-card" style={{ animationDelay: `${i * 0.1}s` }} data-testid={`review-card-${i}`}>
                {r.photo && <img src={r.photo} alt={isAr ? `صورة من جولة ${r.name}` : `${r.name} tour`} className="review-card-photo" loading="lazy" />}
                <div className="ta-stars">{'★★★★★'}</div>
                {r.title && <p className="review-title" data-testid={`review-title-${i}`}>{arText(isAr, r.title, r.titleAr)}</p>}
                <p>{'\u201C'}{arText(isAr, r.quote, r.quoteAr)}{'\u201D'}</p>
                <div className="reviews-showcase-author">
                  <strong>{r.name}</strong>
                  {r.location && <span className="reviews-loc">{metaAr(isAr, r.location, r.locationAr)}</span>}
                  <span className="reviews-date">{metaAr(isAr, r.date, r.dateAr)}</span>
                </div>
                <span className="ta-verified-sm"><i className="fab fa-tripadvisor"></i> {isAr ? 'تقييم موثّق على TripAdvisor' : 'Verified TripAdvisor Review'}</span>
              </a>
            ))}
          </div>
        )}

        <div className="reviews-showcase-cta">
          <a href={TA_URL} target="_blank" rel="noopener noreferrer" className="reviews-showcase-btn" data-testid="reviews-read-all">
            {isAr ? <>اقرأ جميع الـ {TRIPADVISOR_REVIEW_COUNT} تقييماً على TripAdvisor <i className="fas fa-arrow-left"></i></> : <>Read all {TRIPADVISOR_REVIEW_COUNT} reviews on TripAdvisor <i className="fas fa-arrow-right"></i></>}
          </a>
        </div>
      </div>
    </section>
  );
}
